import React, { useContext } from 'react'
import { GeneralContext } from "../context/AppState"

export default function Prestation() {
  const { prestations } = useContext(GeneralContext)

  return (
    <section id="prestation">
      <h2 className="title_deco">Ceux que je peux faire pour vous</h2>

      <ul className="grid">
        {prestations.map((prestation, i) => {
          const { title, Icon, text } = prestation

          return(
            <li className="grid_el" key={i}>
              <Icon className="icon"/>
              <h3> { title } </h3>
              <p> { text } </p>
            </li>
          )

        })}
      </ul>
      
    </section>
  )
}
